import { setEndpoint } from './config';
import { track } from './event_tracker';
import { getIdentity, hasAnalyticsConsent } from './identity';
import { drainJournal } from './queue';

let initialized = false;

/**
 * Initialise the singleton tracker. Call once, before Alpine.start(), so
 * drainJournal() runs before any component can track().
 *
 * The drain is gated on analytics consent: without consent the journal is left
 * intact (not purged) and drains on a future consented page load. The
 * `initialized` re-entry guard means a no-consent init never retries the drain
 * this page load — accepted. drainJournal() needs a current identity to build
 * X-SB-* headers on replay, so it is passed getIdentity() here (mints/refreshes
 * the session, gated behind the consent check).
 *
 * With no argument the config default (/api/event) is used; the `endpoint`
 * argument is an override for tests / other environments only.
 */
export const initTracker = (endpoint?: string): void => {
    if (initialized) return;
    initialized = true;

    // SB-6476 — server-resolved rollout gate; a missing key (older cached pages) means off.
    if (!window.siteData?.global?.eventTrackingEnabled) {
        return;
    }

    if (endpoint !== undefined) {
        setEndpoint(endpoint);
    }

    if (hasAnalyticsConsent()) {
        drainJournal(getIdentity());
    }

    window.sbTracker = { track };
};
